export enum DeclinationExplanationDialogMaxLenghtsEnum {
  REASON_EXPLANATION = 500,
}
